import React, { Component } from 'react';
export default class Dummy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataReady: false
        };
        this.getPsValue = ::this.getPsValue;
        this.getCleanValue = ::this.getCleanValue;
        this.extractParams = ::this.extractParams;
    }

    getPsValue(id, htmlTag, disabledClassName, classNames) {
        let param={};
        if (!(id in this.props.psId)) {
            console.log('Параметра нет в настройках сайта', id, this.constructor.name);
            return null;
        }
        if (this.props.psVal && this.props.psVal[id] && this.props.psVal[id].value!=null) {
            let p=2;
            if (this.props.psId[id].point != null) {p=this.props.psId[id].point}
            var disabled;
            if (id.slice(0,2)=='ti') {
                disabled = (this.props.psVal[id].flags & 7) !== 0;
            }
            else {
                disabled = (this.props.psVal[id].flags & 3) !== 0;
            }

            param= {
                cleaned: this.props.psVal[id].value,
                value: this.props.psVal[id].value.toFixed(p),
                disabled: disabled,
            };
        }
        else {
            param = {
                cleaned: 0,
                value: '?',
                disabled: true,
                firstload: true
            };
        }
        if (htmlTag) {
            let parStyle=[];
            if (classNames) {
                if (Array.isArray(classNames)) {
                    parStyle = classNames;
                }
                else {
                    parStyle = [classNames];
                }
            }
            if (disabledClassName) {
                if (param.disabled && !param.firstload) {
                    parStyle.push(disabledClassName);
                }
            }
            let props = {};
            if (parStyle.length>0) {
                props['className'] = parStyle.join(' ');
            }
            return React.createElement(htmlTag, props, param.value)
        }
        else {
            return param;
        }
    }

    getCleanValue(id) {
        if (this.getPsValue(id)) {
            return this.getPsValue(id).cleaned;
        }
        return 0;
    }

    static clearCanvas(canvasId) {
        var cvs = document.getElementById(canvasId);
        if (cvs.getContext) {
            {
                var ctx = cvs.getContext('2d');
                ctx.clearRect(0, 0, cvs.width, cvs.height);
            }
        }
    }

    extractParams() {
        let disabled = [];
        let params = [];
        let ps=[];
        if(this.props.ps)
        {
            ps = this.props.ps;
            ps.forEach(p=>{
            let val = this.getPsValue(p);
            disabled.push(val.disabled);
            params.push(val.cleaned)
        });
        }
        else disabled = [true];
        params.unshift(disabled.some(element => {
            return element;
        }));
        return params;
    }

    componentDidMount() {
        if (this.props.canvas_id) {
            this.paintCanvas(this.props.canvas_id, ...(this.extractParams()));
        }
    }

    componentDidUpdate() {
        if(this.props.ps) {
            if (this.props.canvas_id) {
                Dummy.clearCanvas(this.props.canvas_id);
                this.paintCanvas(this.props.canvas_id, ...(this.extractParams()));
            }
        }
    }

}




// WEBPACK FOOTER //
// ./src/lib/core/Dummy/index.jsx